import { render, staticRenderFns } from "./AdminVisitors.vue?vue&type=template&id=3b0d8014&scoped=true"
import script from "./AdminVisitors.vue?vue&type=script&lang=js"
export * from "./AdminVisitors.vue?vue&type=script&lang=js"
import style0 from "./AdminVisitors.vue?vue&type=style&index=0&id=3b0d8014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d8014",
  null
  
)

export default component.exports